// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconCompare: React.FC = () => {
    return (
        <svg
            width="15px"
            height="16px"
            viewBox="0 0 15 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(0.000000, 0.875000)" fill="currentColor" fillRule="nonzero">
                    <path d="M14.296875,10.078125 L2.32148409,10.078125 L4.49794918,7.7452147 C4.76367205,7.46191397 4.74902362,7.01660156 4.46484357,6.75292969 C4.18066397,6.48632795 3.73535156,6.50097638 3.47167969,6.78515643 L0.190429688,10.3007814 C-0.0622558594,10.5708691 -0.0622558594,10.9901369 0.190429688,11.2602541 L3.47167969,14.7758791 C3.60937491,14.9238279 3.79687518,15 3.984375,15 C4.15649414,15 4.32861328,14.9377441 4.46425796,14.8104787 C4.74808618,14.5458984 4.76367205,14.1009083 4.49812531,13.8170215 L2.32148409,11.484375 L14.296875,11.484375 C14.6850586,11.484375 15,11.1694336 15,10.78125 C15,10.3930664 14.6865231,10.078125 14.296875,10.078125 Z M0.703125,4.921875 L12.6796871,4.921875 L10.503222,7.2547853 C10.2377334,7.53861308 10.2532902,7.98369169 10.5370894,8.24824244 C10.8199802,8.51466805 11.2659958,8.49908262 11.5305465,8.21437508 L14.8117965,4.69875008 C15.0644821,4.42866236 15.0644821,4.00939465 14.8117965,3.73927742 L11.5305465,0.223652422 C11.3906246,0.0750589371 11.2031248,0 11.015625,0 C10.8435059,0 10.6713867,0.0622558594 10.535742,0.189521313 C10.2519143,0.454101562 10.2363279,0.899091661 10.5018747,1.18297845 L12.6796871,3.515625 L0.703125,3.515625 C0.314941406,3.515625 0,3.83203089 0,4.21875 C0,4.60546911 0.314941406,4.921875 0.703125,4.921875 Z"></path>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconCompare);
